import { useEffect } from 'react';
import useContextMenuProtection from '../../hook/useContextMenuProtection';

interface ContextMenuProtectionProps {
  children: React.ReactNode;
}

/**
 * Komponen wrapper untuk proteksi context menu
 */
const ContextMenuProtection: React.FC<ContextMenuProtectionProps> = ({ children }) => {
  const { isProtectionEnabled } = useContextMenuProtection();

  useEffect(() => {
    if (isProtectionEnabled) {
      // Additional protection styles using proper CSS properties
      const bodyStyle = document.body.style as any;
      bodyStyle.webkitTouchCallout = 'none';

      // Cleanup
      return () => {
        bodyStyle.webkitTouchCallout = '';
      };
    }
  }, [isProtectionEnabled]);

  return <>{children}</>;
};

export default ContextMenuProtection;
